<template>
  <div class="small-12 medium-12 large-6 columns">
    <mobile-basket
      v-model="modelValue.MobilePrice"
      :disclaimer="modelValue.Price.PriceDisclaimer"
    />

    <div class="row policy-basket" data-test-policy-basket>
      <div class="small-12 medium-12 large-10 large-offset-2 columns">
        <price v-model="modelValue.Price" />
        <policy-document
          v-if="modelValue.PolicyDocument.HasDocumentLink"
          v-model="modelValue.PolicyDocument"
        />
        <terms-and-conditions v-model="modelValue.TermsAndConditions" />
        <product-information-document v-model="modelValue.ProductInformationDocument" />
        <policy-buttons :buttonInfo="modelValue.Buttons" />
      </div>
    </div>
  </div>
</template>

<script>
import MobileBasket from './Basket/MobileBasket.vue';
import PolicyDocument from './Basket/PolicyDocument.vue';
import Price from './Basket/Price.vue';
import ProductInformationDocument from './Basket/ProductInformationDocument.vue';
import TermsAndConditions from './Basket/TermsAndConditions.vue';
import PolicyButtons from './Basket/PolicyButtons.vue';

export default {
  name: 'Basket',
  components: {
    Price,
    PolicyDocument,
    TermsAndConditions,
    ProductInformationDocument,
    MobileBasket,
    PolicyButtons
  },
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};
</script>
